module.exports = __webpack_public_path__ + "img/orange.b0da615b.svg";